(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mlfa-recommendations')){customElements.define('mlfa-recommendations',class extends HTMLElement{
 connectedCallback(){if(this.dataset.loaded)return;this.dataset.loaded='true';const load=async()=>{try{const response=await fetch(this.dataset.url);if(!response.ok)throw new Error('Recommendations unavailable');const documentFragment=new DOMParser().parseFromString(await response.text(),'text/html');const content=documentFragment.querySelector('mlfa-recommendations .related-merch');if(content)this.replaceChildren(content);else this.remove()}catch{this.remove()}};if('IntersectionObserver' in window){this.observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){this.observer.disconnect();load()}},{rootMargin:'300px'});this.observer.observe(this)}else load()}
 disconnectedCallback(){this.observer?.disconnect()}
})}

  } catch(e) { console.error(e); }
})();
})();
